"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = _interopRequireDefault(require("immutable"));

var GroupTag = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Group"));

var ScopeGroup = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/scopes/ScopeGroup"));

var _DataSync = _interopRequireDefault(require("ecosystem-marketplace-core/records/DataSync"));

var _Pricing = _interopRequireDefault(require("ecosystem-marketplace-core/records/Pricing"));

var _Screenshot = _interopRequireDefault(require("ecosystem-marketplace-core/records/Screenshot"));

var _Working = _interopRequireDefault(require("ecosystem-marketplace-core/records/Working"));

var _formatters = require("ecosystem-marketplace-core/utils/formatters");

var _groupTags = require("ecosystem-marketplace-core/utils/groupTags");

var _offerings = require("ecosystem-marketplace-core/utils/offerings");

var _AppInstallability = _interopRequireDefault(require("ecosystem-marketplace-core/records/AppInstallability"));

var _AppReviewability = _interopRequireDefault(require("./AppReviewability"));

var _SocialScreenshots = _interopRequireDefault(require("./SocialScreenshots"));

var _ThinOffering = _interopRequireDefault(require("./ThinOffering"));

var _ThinVersion = _interopRequireDefault(require("./ThinVersion"));

var _Immutable$Map;

var EMPTY_LIST = _immutable.default.List();

var EMPTY_SET = _immutable.default.Set();

var scopeGroupValues = _immutable.default.Set(Object.values(ScopeGroup));

var buildScopeGroupsSet = function buildScopeGroupsSet(scopeGroups) {
  return _immutable.default.Set(scopeGroups).filter(function (scopeGroup) {
    return scopeGroupValues.includes(scopeGroup);
  });
};

var defaultGroupTags = _immutable.default.Map((_Immutable$Map = {}, (0, _defineProperty2.default)(_Immutable$Map, GroupTag.CATEGORY, EMPTY_SET), (0, _defineProperty2.default)(_Immutable$Map, GroupTag.CATEGORY_FEATURES, EMPTY_SET), (0, _defineProperty2.default)(_Immutable$Map, GroupTag.APP_INTEGRATIONS, EMPTY_SET), (0, _defineProperty2.default)(_Immutable$Map, GroupTag.KEYWORDS, EMPTY_SET), (0, _defineProperty2.default)(_Immutable$Map, GroupTag.SUPPORT_LANGUAGES, EMPTY_SET), (0, _defineProperty2.default)(_Immutable$Map, GroupTag.TIERS, EMPTY_SET), (0, _defineProperty2.default)(_Immutable$Map, GroupTag.HUBSPOT_FEATURES, EMPTY_SET), _Immutable$Map));

var defaults = {
  agencyPricingUrl: null,
  appUrl: '',
  benefits: '',
  casesUrl: null,
  chatUrl: null,
  companyName: '',
  companyUrl: null,
  dataSyncInfo: null,
  dataSyncs: EMPTY_LIST,
  email: '',
  facebookUrl: null,
  forumUrl: null,
  groupTags: defaultGroupTags,
  iconUrl: '',
  id: 0,
  installability: new _AppInstallability.default(),
  installed: false,
  name: '',
  offering: new _ThinOffering.default(),
  offeringId: 0,
  phone: null,
  pricingUrl: null,
  pricings: EMPTY_LIST,
  privacy2Url: null,
  privacy3Url: null,
  privacyUrl: '',
  queueDepth: null,
  requiredRelevantScopes: EMPTY_SET,
  requiredScopeGroups: EMPTY_SET,
  reviewNotes: null,
  reviewability: new _AppReviewability.default(),
  reviewSummary: null,
  screenshots: EMPTY_LIST,
  setupUrl: '',
  socialScreenshots: new _SocialScreenshots.default(),
  supportUrl: null,
  tagline: '',
  termsUrl: '',
  updatedAt: null,
  updatedByUserId: null,
  version: new _ThinVersion.default(),
  videoUrl: null,
  workings: EMPTY_LIST
};

var ListingView = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(ListingView, _Immutable$Record);

  function ListingView() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ListingView);
    var dataSyncs = json.dataSyncs,
        groupTags = json.groupTags,
        installability = json.installability,
        offering = json.offering,
        pricings = json.pricings,
        requiredRelevantScopes = json.requiredRelevantScopes,
        requiredScopeGroups = json.requiredScopeGroups,
        reviewability = json.reviewability,
        screenshots = json.screenshots,
        socialScreenshots = json.socialScreenshots,
        version = json.version,
        workings = json.workings;

    if (dataSyncs) {
      json.dataSyncs = _immutable.default.List(dataSyncs).map(function (item) {
        return new _DataSync.default(item);
      });
    }

    if (offering) {
      json.offering = new _ThinOffering.default(offering);
    }

    if (groupTags) {
      json.groupTags = defaultGroupTags.merge(Object.keys(groupTags).reduce(function (final, key) {
        return (0, _extends3.default)({}, final, (0, _defineProperty2.default)({}, key, _immutable.default.Set(groupTags[key])));
      }, {}));
    }

    if (installability) {
      json.installability = new _AppInstallability.default(installability);
    }

    if (reviewability) {
      json.reviewability = new _AppReviewability.default(reviewability);
    } else {
      json.reviewability = new _AppReviewability.default({
        isPublic: true
      });
    }

    if (pricings) {
      json.pricings = _immutable.default.List(pricings).map(function (item) {
        return new _Pricing.default(item);
      });
    }

    if (requiredRelevantScopes) {
      json.requiredRelevantScopes = buildScopeGroupsSet(requiredRelevantScopes);
    }

    if (requiredScopeGroups) {
      json.requiredScopeGroups = buildScopeGroupsSet(requiredScopeGroups);
    }

    if (screenshots) {
      json.screenshots = _immutable.default.List(screenshots).map(function (item) {
        return new _Screenshot.default(item);
      });
    }

    if (socialScreenshots) {
      json.socialScreenshots = new _SocialScreenshots.default(socialScreenshots);
    }

    if (version) {
      json.version = new _ThinVersion.default(version);
    }

    if (workings) {
      json.workings = _immutable.default.List(workings).map(function (item) {
        return new _Working.default(item);
      });
    }

    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListingView).call(this, (0, _formatters.cleanObject)(json)));
  }

  (0, _createClass2.default)(ListingView, [{
    key: "getCategory",
    value: function getCategory() {
      return this.getIn(['groupTags', GroupTag.CATEGORY]).first();
    }
  }, {
    key: "getSuperCategory",
    value: function getSuperCategory() {
      var category = this.getCategory();
      return (0, _groupTags.getCategorySuperCategory)(category);
    }
  }, {
    key: "getNativeId",
    value: function getNativeId() {
      return this.getIn(['version', 'nativeId']);
    }
  }, {
    key: "getAppId",
    value: function getAppId() {
      var nativeId = this.getNativeId();
      return nativeId ? parseInt(nativeId, 10) : null;
    }
  }, {
    key: "getIsPieSyncConnector",
    value: function getIsPieSyncConnector() {
      return (0, _offerings.getIsPieSyncConnector)(this.getNativeId(), this.offeringId);
    }
  }, {
    key: "getEventProperties",
    value: function getEventProperties() {
      var installability = this.installability;
      var applicationId = this.getAppId();
      var isPieSyncConnector = this.getIsPieSyncConnector();
      return {
        applicationId: applicationId,
        applicationName: this.name,
        category: this.getSuperCategory(),
        subcategory: this.getCategory(),
        // hasExternalConnectFlow: null,
        isCompatible: installability.hubInstallable || undefined,
        isInstallableByUser: installability.hubUserInstallable || undefined,
        // isNotInstallableReason: null,
        homemade: this.getIn(['offering', 'homemade']),
        offeringId: this.offeringId,
        ipaasApplicationName: isPieSyncConnector ? 'PieSync' : undefined,
        ipaasApplicationId: isPieSyncConnector ? applicationId : undefined
      };
    }
  }]);
  return ListingView;
}(_immutable.default.Record(defaults));

var _default = ListingView;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/records/ListingView.js
// module id = 769
// module chunks = 209 210 211 212